// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f28c3b18","453":"99b21756","455":"c9a395ee"}[chunkId] + ".chunk.js";
};